import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { EXPORT_FILES_LABELS } from '@/pages/diagnosis-view/cultures/weed/create-pulverization-map-stepper/pulverization-summary/export-files-menu'
import {
  DownloadTypes,
  getURLToDownloadFile,
} from '@/services/get-url-to-download-file'

export const INDIVIDUAL_DOWNLOAD_FILES_FROM_DEMAND_KEY =
  'individual-download-files-from-demand'

export function useIndividualDownloadFilesFromDemand(
  culture: string,
  demandId: string,
  fileType: DownloadTypes,
) {
  return useMutation({
    mutationKey: [
      INDIVIDUAL_DOWNLOAD_FILES_FROM_DEMAND_KEY,
      culture,
      demandId,
      fileType,
    ],
    mutationFn: async ({ waitInMs = 0 }: { waitInMs?: number } = {}) => {
      const url = await getURLToDownloadFile(culture, demandId, fileType)

      const link = document.createElement('a')
      link.href = url
      link.download = ''

      await new Promise((resolve) => setTimeout(resolve, waitInMs))

      link.click()
    },
    onError(error: any) {
      toast.error(
        `Ocorreu um erro ao realizar o download do arquivo: ${
          EXPORT_FILES_LABELS[fileType as keyof typeof EXPORT_FILES_LABELS]
        } [${error?.message}]`,
      )
    },
  })
}
